<template>
  <div id="contractSee">
    <div class="doc-context" v-loading="fileLoading">
      <div class="doc-main">
        <div class="doc-list-context" v-if="fileList.length > 0">
          <div class="doc-list-title">
            {{ $t('文件') }}
            <span>{{ $t('（{slot1}份）', {
              slot1: fileList.length
            }) }}</span>
          </div>
          <ul class="doc-list">
            <li
              :class="['doc-item', { 'doc-item-cur': index == isActive }]"
              v-for="(item, index) in fileList"
              :key="item.fileId"
              @click="selectDoc(item, index)"
            >
              {{ item.fileName }}
            </li>
          </ul>
        </div>
        <div class="doc-view">
          <PdfJs
            :withCredentials="false"
            :loading="pdfLoading"
            :src="currentSrc"
            @start="pdfLoading = true"
            @end="pdfLoading = false"
            v-if="currentSrc"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PdfJs from '@/components/pdfJs.vue'

export default {
  data() {
    return {
      pdfLoading: false, // PDF加载状态
      fileLoading: false,
      currentSrc: null, // 选中的PDF地址
      fileList: [], // 文件列表
      isActive: 0, // 当前文件索引

      contractBody: {},
      contractId: this.$router.currentRoute.query.contractId,
      Jurisdiction: [],
    }
  },
  components: {
    PdfJs,
  },
  mounted() {
    this.getDocView()
  },
  methods: {
    getDocView() {
      this.fileLoading = true
      this.$ajax(this.$url.viewContractFile(this.$route.query.contractId), {})
        .then((res) => {
          this.fileList = res.data
          if (this.fileList.length > 0) {
            this.currentSrc = this.fileList[0].fileDownloadUrl
          } else if (res.data.onLineContractPdfUrl) {
            this.currentSrc = res.data.onLineContractPdfUrl
          }
          this.fileLoading = false
        })
        .catch(() => {
          this.fileLoading = false
        })
    },
    /**
     * 点击预览PDF文件
     * @param { Object } item  文件对象
     * @param { Number } index 文件序号
     */
    selectDoc(item, index) {
      if (this.pdfLoading || this.isActive === index) return
      this.isActive = index
      this.currentSrc = null
      this.$nextTick(() => {
        this.currentSrc = item.fileDownloadUrl
      })
    },
  },
}
</script>
<style lang="less" scoped>
#contractSee {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
  text-align: left;
}
.footer {
  width: 100%;
  height: 54px;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.1);
}
.doc-context {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  .doc-main {
    overflow: hidden;
    padding: 20px 20px 54px;
    box-sizing: border-box;
    flex: 1;
    width: 100%;
    display: flex;
  }
  .doc-view {
    background: #fff;
    border: 1px solid #e1e1e1;
    border-bottom: none;
    flex: 1;
    overflow: auto;
    text-align: center;
  }
}
.doc-list-context {
  margin-right: 20px;
  width: 240px;
  border: 1px solid #e1e1e1;
  border-bottom: none;
  padding: 0 15px 15px;
  background-color: #fdfdfd;
  .doc-list {
    overflow-y: auto;
    width: 100%;
    height: calc(100% - 51px);
    padding: 10px 0 0;
  }
  .doc-item {
    margin: 0;
    cursor: pointer;
    color: #333;
    font-size: 12px;
    padding: 15px 10px;
    line-height: 16px;
    word-break: break-all;
    transition: 0.3s background;
    &.doc-item-cur,
    &:hover {
      background: #f2f5f7;
    }
  }
  .doc-list-title {
    font-size: 14px;
    font-weight: 800;
    color: #333;
    line-height: 40px;
    height: 40px;
    width: 100%;
    border-bottom: 1px solid #eaeaea;
    span {
      color: #777;
      font-size: 12px;
      line-height: 40px;
    }
  }
}
</style>
